import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import Tabs from '@spotnana/pixel-react/dist/Tabs';
import Box, { Flex } from '@spotnana/pixel-react/dist/Box';
import Direction from '@spotnana/pixel-react/dist/Icons/Direction';
import cssWrapper from '@spotnana/pixel-react/dist/utils/cssWrapper';
import theme from '@spotnana/pixel-react/dist/utils/themes/theme';

export const Container = styled(Box)(
  cssWrapper({
    marginTop: '8px',
    marginBottom: '25px',
  }),
);

export const StopInfoContainer = styled(Flex)<{ isActive: boolean }>(
  cssWrapper({
    fontSize: 'body',
    lineHeight: 'label',
    alignItems: 'center',
  }),
  ({ isActive }): FlattenSimpleInterpolation =>
    isActive
      ? css({
          color: 'semiBold',
          fontWeight: theme.fontWeights.semiBold,
        })
      : css({
          color: 'text.label',
        }),
);

export const ArrowIcon = styled(Direction)(
  cssWrapper({
    margin: '0 2px',
    height: '24px',
    width: '24px',
  }),
);

export const StyledTabs = styled(Tabs.Horizontal)`
  padding: 0;
  overflow: auto;

  & .tab-button {
    margin: 0;
    margin-right: 10px;
    padding: 20px 0px;
  }
`;
